import { resolvePlanTier } from "../constants/pricingScreen";

export const isEnterpriseDunningPlan = (planId) =>
  resolvePlanTier(planId) === "enterprise";

/** Past-due grace-period consequence (appended after "update your payment method "). */
export const dunningPastDueUntil = (planId) =>
  isEnterpriseDunningPlan(planId)
    ? "until your account is locked"
    : "before your account is downgraded to Free";

export const dunningUnpaidTitle = (planId) =>
  isEnterpriseDunningPlan(planId)
    ? "Your account is locked. Subscription unpaid"
    : "Your account was downgraded to Free. Subscription unpaid";

export const dunningUnpaidBillingTitle = (planId) =>
  isEnterpriseDunningPlan(planId)
    ? "Your subscription is unpaid. Account locked"
    : "Your subscription is unpaid. Plan downgraded to Free";
